

/* { 
  name: '',
  website: '',
  logo: '',
  score: ,
  columns: ['', 'X', '',  '', '',''],
  description: '',
  socialHandles: [''],
  videos: [],
  longerDescription: '',
}, */


const librariesNodesAds =[
      { 
        name: 'Cash Script',
        website: 'cashscript.org',
        logo: 'cashscript.png',
        description: 'CashScript is a high-level programming language for smart contracts on Bitcoin Cash.',
        socialHandles: ['twitter.com/CashScriptBCH','twitter.com/CashScriptBCH'],
        videos: [],
        longerDescription: `It offers a strong abstraction layer over Bitcoin Cash\'s native virtual machine, Bitcoin Script. Its syntax is based on Ethereum\'s smart contract language Solidity, but its functionality is very different since smart contracts on Bitcoin Cash differ greatly from smart contracts on Ethereum 
        \n  The development version of this website and its documentation that may be helpful for developers check out https://next.cashscript.org/`,
        tags:[],
      }, { 
        name: 'Mainnet.cash',
        website: 'mainnet.cash/',
        logo: 'bch.png',
        description: ' Develop using Bitcoin Cash. Tutorials for JavaScript, REST API, SmartBCH, and CashScript.',
        socialHandles: ['t.me/mainnetcash','github.com/mainnet-cash/'],
        videos: [],
        longerDescription: '',
        tags:[],
      },
      { 
        name: 'Bitcoin Unlimited Node',
        website: 'www.bitcoinunlimited.info/',
        logo: 'unlimited.png',
        description: 'Bitcoin Cash Unlimited node implementation and technology development team. Governed by a Community Organization.',
        socialHandles: ['t.me/bitcoinunlimit','gitlab.com/bitcoinunlimited/BCHUnlimited/-/issues','twitter.com/bitcoinunlimit'],
        videos: [],
        longerDescription: '',
        tags:[],
      },
      { 
        name: 'Bitcoin Cash Node',
        website: 'bitcoincashnode.org/en/',
        logo: 'bchn.png',
        description: 'A professional, miner-friendly node that solves practical problems for Bitcoin Cash',
        socialHandles: ['t.me/bitcoincashnode','twitter.com/bitcoincashnode','gitlab.com/bitcoin-cash-node/bchn-sw/bchnode-web','bitcoincashnode.slack.com/join/shared_invite/zt-egg3c36d-2cglIrKcbnGpIQFaKFzCWA#/shared-invite/email'],
        videos: [],
        longerDescription: '',
        tags:[],
      },
      { 
        name: 'Knuth Node',
        website: 'kth.cash/',
        logo: 'knuth.png',
        description: ' Knuth is a high performance implementation of the Bitcoin protocol. It is a full node software client, but also a development platform.',
        socialHandles: ['github.com/k-nuth/kth','twitter.com/KnuthNode','t.me/knuth_cash','k-nuth.slack.com/'],
        videos: [],
        longerDescription: 'Knuth is characterized by its modular architecture and beautiful code. It has the intention to facilitate adoption and collaboration in the evolution of a diverse ecosystem. We want our code to be interactive, reusable and reliable, easy to read and easy to debug. Some of our features are: ',
        tags:[],
      },
      { 
        name: 'Flowee',
        website: 'flowee.org/',
        logo: 'flowee.png',
        description: 'Full-node and family of products. Our goal is to move the world towards a Bitcoin Cash economy.',
        socialHandles: ['twitter.com/FloweeTheHub','t.me/Flowee_org'],
        videos: [],
        longerDescription: `Keep the Flow going with our applications: Flowee Pay, JS, Fulcrum, Indexer, The hub, Tx Vulcano. \n
        Flowee Pay Is a payment solution, and a desktop wallet. \n
        Flowee Js Gives you powerful tools to search the chain and naturally to create and send transations. \n
        Flowee fulcrum Is your server that provides Blockchain data to your applications, webapps, and SPV wallets. \n
        Flowee Indexer Is your librarian effortlessly cataloging the worlds transaction data to allow you to use the Blockchain. \n
        Flowee The Hub Build most of your infrastructure around the hub, a full node that validates the blochain for your buisness. \n
        Flowee tx Vulcano test your application and services safely with massive amounts of transcations. `,
        tags:[],
      },
      { 
        name: 'Bitcoin Verde',
        website: 'bitcoinverde.org/',
        logo: 'verde.png',
        description: 'Bitcoin Verde provides the BCH network with a full-node implementation, a block explorer, and development library. ',
        socialHandles: ['twitter.com/softwareverde','www.facebook.com/SoftwareVerde/','github.com/softwareverde/bitcoin-verde','www.instagram.com/softwareverdellc/','www.linkedin.com/company/software-verde-llc/'],
        videos: [],
        longerDescription: 'A Bitcoin Cash full-node written in Java. Unique codebase providing increased security to the Bitcoin Cash network. Multithreaded performance supports over 200 transactions per second. Stable and Fault tolerant. A system that has been well tested. Suitable for mining and for network validation. ',
        tags:[],
      },
      { 
        name: 'SLPJS',
        website: 'github.com/simpleledger/slpjs',
        logo: 'slp.png',
        description: 'SLPJS is a JavaScript Library for validating and building Simple Ledger Protocol token transactions',
        socialHandles: [],
        videos: [],
        longerDescription: '',
        tags:[],
      },
      { 
        name: 'CashStack',
        website: 'permissionless-software-foundation.github.io/cashstack.info/',
        logo: 'cashstack.png',
        description: 'Cash Stack is a framework for building Web 2 and Web 3 applications on the BCH, eCash, AVAX X-Chain, and other UTXO-based blockchains',
        socialHandles: ['t.me/bch_js_toolkit','twitter.com/PSF_DAO','github.com/Permissionless-Software-Foundation/cashstack.info'],
        videos: [],
        longerDescription: 'Read about the differnet layers of the CashStack framework, and the different open source projects that it is made from.',
        tags:[],
      },
      { 
        name: 'Libauth',
        website: 'libauth.org/',
        logo: 'libauth.png',
        description: 'An ultra-lightweight JavaScript library for Bitcoin Cash, Bitcoin, and Bitauth applications.',
        socialHandles: ['twitter.com/libauth','t.me/libauth_dev','github.com/bitauth/libauth'],
        videos: [],
        longerDescription: 'bauth is designed to be flexible, lightweight, and easily auditable. Rather than providing a single, overarching, object-oriented API, all functionality is composed from simple functions.',
        tags:[],
      },
      { 
        name: 'BchAddr.js',
        website: 'www.npmjs.com/package/bchaddrjs',
        logo: 'nologo.png',
        description: 'BchAddr.js: Bitcoin Cash general purpose address translation for Node.js and web browsers',
        socialHandles: ['github.com/npm'],
        videos: [],
        longerDescription: `Plug & Play JavaScript library for all Bitcoin Cash address format translation needs. Easy-to-use, thoroughly tested, and feature complete.
              \n Support for the new Bitcoin Cash address format which improves upon BIP 173, as well as the Bitpay and Legacy formats.`,
              tags:[],
            },
      { 
        name: 'BCH Util',
        website: 'github.com/gcash/bchutil',
        logo: 'nologo.png',
        description: 'Provides bitcoin cash-specific convenience functions and types',
        socialHandles: [],
        videos: [],
        longerDescription: '',
        tags:[],
      },
      { 
        name: 'Bitcoin-Cash Library',
        website: 'github.com/be-cash/bitcoin-cash',
        logo: 'nologo.png',
        description: 'A library for creating and parsing Bitcoin Cash trasactions ',
        socialHandles: [],
        videos: [],
        longerDescription: '',
        tags:[],
      },
      { 
        name: 'Haskoin-Core ',
        website: 'github.com/haskoin/haskoin-core',
        logo: 'haskoin.png',
        description: 'Haskoin Core is a Bitcoin and Bitcoin Cash library ',
        socialHandles: [],
        videos: [],
        longerDescription: '',
        tags:[],
      },
      { 
        name: 'BCH-js',
        website: 'github.com/Permissionless-Software-Foundation/bch-js',
        logo: 'bchjs.png',
        description: 'A JS library for working with the Bitcoin Cash and eCash blockchains. ',
        socialHandles: [],
        videos: [],
        longerDescription: 'bch-js is a JavaScript npm library for creating web and mobile apps that can interact with the Bitcoin Cash (BCH) and eCash (XEC) blockchains. bch-js contains a toolbox of handy tools, and an easy API for talking with bch-api REST API. FullStack.cash offers paid cloud access to bch-api. You can run your own infrastructure by following documentation on CashStack.info.',
        tags:[],
      },
      { 
        name: 'Electrum-Cash Library',
        website: 'gitlab.com/electrum-cash/library',
        logo: 'electrumcash.png',
        description: 'Electrum-Cash is a lightweight JavaScript library that lets you connect with one or more Electrum servers.',
        socialHandles: ['t.me/electrumcash','discord.com/invite/ZjXQzew'],
        videos: [],
        longerDescription: '',
        tags:[],
      },
      { 
        name: 'CashPayServer',
        website: 'developers-cash.github.io/cash-pay-server-js/',
        logo: 'cashpayserver.png',
        description: 'Javascript/Node library for use with Cash Pay Server.',
        socialHandles: ['t.me/jimtendo','github.com/developers-cash/cash-pay-server-js/issues'],
        videos: [],
        longerDescription: 'CashPayServer is a self-hostable NodeJS micro-service that can be used to handle BIP70 and JSON Payment Protocol invoices for Bitcoin Cash (BCH). This allows services to receive payments in BCH and attach arbitrary information to each transaction (e.g. Invoice Numbers, Order Details, etc).',
        tags:[],
      },
      { 
        name: 'BitcoinCash Client',
        website: 'github.com/david-shattuck/BitcoinCashClient',
        logo: 'bch.png',
        description: 'Makes it trivially easy to integrate native BCH transactions into any C# .NET application with internet access.',
        socialHandles: ['github.com/david-shattuck/BitcoinCashClient'],
        videos: ['https://www.youtube.com/embed/l6h8qI2oWT0'],
        longerDescription: `BitcoinCashClient makes it trivially easy to integrate native (non-custodial) Bitcoin Cash transactions into any C# .NET application with internet access.
              This library provides a simple interface enabling on-chain sending and receiving of Bitcoin Cash by abstracting away as much complexity as possible. 
              \n Wallet (private key and public address) creation, fetching wallet info from a block explorer, fetching up-to-date price data, managing utxos (hashes and indexes), inputs and outputs, network fee calculation, transaction signing, and broadcasting to the network are ALL handled by this library behind the scenes.`,
              tags:[],
            },
      { 
        name: 'AnyHedge',
        website: 'anyhedge.com/',
        logo: 'anyhedge.png',
        description: 'Build using the AnyHedge libraries, or expand on our open source contracts.',
        socialHandles: ['t.me/AnyHedge','twitter.com/AnyHedge','gitlab.com/GeneralProtocols/anyhedge'],
        videos: ['https://www.youtube.com/embed/CpVgudYunB4?si=FiZTZJbOvTtAbCv1'],
        longerDescription: 'AnyHedge allows you to take leveraged long positions or hedge your fiat value. Permissionless, non-custodial, and on-chain. AnyHedge is the technology that powers BCH Bull. It lets you take BCH long positions with up to 5x leverage against a variety of assets.',
        tags:[],
      },
  ]  

export default librariesNodesAds